import StartIcon from '../../../../assets/re-star.svg?react';
import styles from './FJAIGenerateButton.module.less';
import FJLocalStore from '@src/store/FJLocalStore';

const FJAIGenerateButton = ({ onClick }: { onClick?: () => void }) => {
    return (
        <div className={styles.button} onClick={onClick}>
            <StartIcon />
            <p>{FJLocalStore._('ai-generate')}</p>
        </div>
    );
};

export default FJAIGenerateButton;
